import { useTranslation } from 'react-i18next'

const formatMoney = value => {
	const normalizedValue = `${value ?? ''}`.trim()
	return normalizedValue ? `${normalizedValue} PLN` : '—'
}

export default function MyTrainingTrainersSection({ trainerRows, currentTrainerName }) {
	const { t } = useTranslation()

	return (
		<div className="rounded-md border border-gray-200 bg-white px-5 py-4 shadow-sm">
			<h2 className="text-sm font-semibold text-gray-900">{t('trainings.details.sections.trainers')}</h2>

			<div className="mt-4 space-y-3">
				{trainerRows.length ? trainerRows.map(trainer => {
					const isCurrentTrainer = currentTrainerName
						&& `${trainer.trainerName || ''}`.trim().toLowerCase() === `${currentTrainerName}`.trim().toLowerCase()

					return (
						<div key={trainer.key} className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
							<div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
								<div className="min-w-0 flex-1">
									<p className="text-sm font-semibold text-gray-900">{trainer.trainerName || '—'}</p>
								</div>
							</div>

							{isCurrentTrainer ? (
								<dl className="mt-4 grid grid-cols-1 gap-3 border-t border-gray-100 pt-4 sm:grid-cols-2">
									<>
										<div>
											<div className="text-xs font-medium uppercase tracking-wide text-gray-500">
												{t('myTrainings.details.fields.yourHourlyRateGross')}
											</div>
											<div className="mt-1 text-gray-900">
												{formatMoney(trainer.hourlyRateGross)}
											</div>
										</div>
										<div>
											<div className="text-xs font-medium uppercase tracking-wide text-gray-500">
												{t('myTrainings.details.fields.yourExtraAmountGross')}
											</div>
											<div className="mt-1 text-gray-900">
												{formatMoney(trainer.extraAmountGross)}
											</div>
										</div>
									</>
								</dl>
							) : null}
						</div>
					)
				}) : (
					<div className="text-sm text-gray-500">{t('trainings.details.emptyTrainers')}</div>
				)}
			</div>
		</div>
	)
}
